// extracted by mini-css-extract-plugin
export default {"inputs":"_3huSHRiw","dayRateContainer":"NaJF-SZv","dayRate":"_57pm9UBU","error":"_1bR2cZSP"};